export default __webpack_public_path__ + "static/media/Asset-76.1ddee10d.png";